import React, { useState } from 'react'
import { Tabs, Card, Badge, Space } from 'antd'
import {
  DollarOutlined,
  FileTextOutlined,
  SwapOutlined,
  HistoryOutlined,
  SolutionOutlined,
  TeamOutlined
} from '@ant-design/icons'
import FollowUpManager from '../FollowUpManager/FollowUpManager'
import PatientAccountsList from '../PatientAccounts/PatientAccountsList'
import { CreditNoteManager } from '../CreditNotes'
import { RefundManager } from '../Refunds'
import { PaymentAllocationManager } from '../PaymentAllocation'
import { AuditTrailViewer } from '../AuditTrail'

const BillingDashboard = () => {
  const [activeTab, setActiveTab] = useState('accounts')

  const tabItems = [
    {
      key: 'accounts',
      label: (
        <span>
          <TeamOutlined />
          Patient Accounts
        </span>
      ),
      children: <PatientAccountsList />
    },
    {
      key: 'followup',
      label: (
        <span>
          <SolutionOutlined />
          Follow-up Manager
        </span>
      ),
      children: <FollowUpManager />
    },
    {
      key: 'creditnotes',
      label: (
        <span>
          <FileTextOutlined />
          Credit Notes
        </span>
      ),
      children: <CreditNoteManager />
    },
    {
      key: 'refunds',
      label: (
        <span>
          <SwapOutlined />
          Refunds
        </span>
      ),
      children: <RefundManager />
    },
    {
      key: 'allocation',
      label: (
        <span>
          <DollarOutlined />
          Payment Allocation
        </span>
      ),
      children: <PaymentAllocationManager />
    },
    {
      key: 'audit',
      label: (
        <span>
          <HistoryOutlined />
          Audit Trail
        </span>
      ),
      children: <AuditTrailViewer />
    }
  ]

  return (
    <Card title='Billing & Collections Dashboard' className='billing-dashboard' bodyStyle={{ padding: 0 }}>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
        tabBarStyle={{ paddingLeft: 24, paddingRight: 24 }}
      />
    </Card>
  )
}

export default BillingDashboard
